export default __webpack_public_path__ + "static/beautyImage-c066a9fd2b963192a2eafa22958998c1.webp";